import React from 'react';
import { connect } from 'react-redux';
import { Badge, Button, Overlay, Popover } from 'react-bootstrap';
import { SketchPicker } from 'react-color';
import { IntlProvider } from 'react-intl';

import { getTextColor } from 'components/forms/autocomplete/Color';

class CmsColorSelector extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      show: false,
      placement: 'left',
    };

    this.badgeRef = React.createRef();
  }

  componentWillUnmount = () => {
    clearTimeout(this.timeout);
  };

  handleChange = color => {
    const { type, setParam } = this.props;
    setParam(type + 'Color', color.hex);
    clearTimeout(this.timeout);

    this.timeout = setTimeout(this.hide, 5000);
  };

  resetBackground = () => {
    const { type, setParam, resetColor } = this.props;
    setParam(type + 'Color', resetColor);
  };

  show = e => {
    const { layoutWidth } = this.props;

    const element = e.target;
    const bb = element.getBoundingClientRect();
    const boxCenter = bb.left + bb.width / 2;
    const layoutCenter = layoutWidth / 2;

    this.setState({ show: true, placement: boxCenter < layoutCenter ? 'right' : 'left' });
  };

  hide = () => {
    this.setState({ show: false });
  };

  render() {
    const { intl, type, disableAlpha, label, getParamValue, projectConfig, disabled } = this.props;
    const { show, placement } = this.state;

    const color = getParamValue(type + 'Color', 'transparent');

    const presetColors = [];
    if (projectConfig.data.theme_colors && projectConfig.data.theme_colors.length) {
      for (let i = 0; i < projectConfig.data.theme_colors.length; i++) {
        presetColors.push({
          title: projectConfig.data.theme_colors[i].name,
          color: projectConfig.data.theme_colors[i].color,
        });
      }
    }

    const colorBadge = (
      <Badge
        ref={this.badgeRef}
        style={{ background: color, color: getTextColor(color) }}
        className="p-l-10 p-r-10 cursor"
        onClick={!disabled && this.show}
      >
        {color}
      </Badge>
    );

    return (
      <div className="form-group form-group-default" style={{ position: 'relative' }}>
        <label>{label}</label>
        <div className="relative" style={{ width: '100%' }}>
          {disabled ? (
            colorBadge
          ) : (
            <>
              <Overlay
                rootClose
                placement={placement}
                show={show}
                onHide={this.hide}
                target={() => this.badgeRef.current}
              >
                <Popover className="popover-modal">
                  <IntlProvider locale={intl.locale} messages={intl.messages}>
                    <SketchPicker
                      disableAlpha={disableAlpha}
                      presetColors={presetColors}
                      color={color}
                      onChange={this.handleChange}
                    />
                  </IntlProvider>
                </Popover>
              </Overlay>

              {colorBadge}
            </>
          )}

          <Button className="text-danger pull-right" bsSize="xsmall" onClick={this.resetBackground} disabled={disabled}>
            <i className="fa fa-times" />
          </Button>
        </div>
      </div>
    );
  }
}
CmsColorSelector.defaultProps = {
  type: 'background',
  disableAlpha: true,
  resetColor: 'transparent',
  disabled: false,
};

const mapStateToProps = state => {
  return {
    intl: state.intl,
    projectConfig: state.data.projectConfig,
    layoutWidth: state.layout.width,
  };
};

export default connect(mapStateToProps)(CmsColorSelector);
